var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"login-section"},[_c('div',{staticClass:"thumb-container absolute",style:("background-image: url(" + _vm.footer.bg4_url + ")")}),_c('div',{staticClass:"container"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }